export default __webpack_public_path__ + "static/media/contact4.3e81b55d.png";